import React from 'react';
import { ClienteSelector } from '../entrada/clienteSelector.js';

export const ClienteStep = ({ clientes }) => {
  return <ClienteSelector usuarios={clientes} />;
};
